import { Check } from "lucide-react";

/**
 * Horizontal wizard stepper. Steps up to `maxReachable` are clickable so the
 * estimator can jump back (state is kept by the wizard).
 */
export default function Stepper({ steps, current, maxReachable, onStepClick }) {
  return (
    <nav aria-label="Estimate wizard progress">
      <ol className="flex items-center gap-2">
        {steps.map((step, i) => {
          const done = i < current;
          const active = i === current;
          const reachable = i <= maxReachable;
          return (
            <li key={step.label} className={`flex items-center gap-2 ${i < steps.length - 1 ? "flex-1" : ""}`}>
              <button
                type="button"
                disabled={!reachable || active}
                onClick={() => onStepClick(i)}
                aria-current={active ? "step" : undefined}
                className="flex items-center gap-2.5 rounded-[4px] px-1 py-1 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-border_strong disabled:cursor-default"
              >
                <span
                  className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border text-[12px] font-semibold ${
                    done
                      ? "border-primary bg-primary text-white"
                      : active
                      ? "border-secondary bg-secondary text-white"
                      : "border-border bg-surface text-text_muted"
                  }`}
                >
                  {done ? <Check size={14} aria-hidden="true" /> : i + 1}
                </span>
                <span className="min-w-0">
                  <span className={`block whitespace-nowrap text-[12.5px] font-semibold ${active || done ? "text-text_primary" : "text-text_muted"}`}>
                    {step.label}
                  </span>
                  <span className="hidden whitespace-nowrap text-[11px] text-text_muted md:block">{step.hint}</span>
                </span>
              </button>
              {i < steps.length - 1 && (
                <span className={`h-px flex-1 ${done ? "bg-primary" : "bg-border"}`} aria-hidden="true" />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
